module.exports = __webpack_public_path__ + "/login_ui/img/et-5c4f6d95578db130a5a82f076602a934.svg";